import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { TransformedGGHResponse } from '@lt/api/dist/methods/search/types';

import type { EmptyFiltrationState } from './types';

import { CLEAR_FILTERS } from '../../constants/filters';
import { SEARCH_SUCCESS, CHANGE_SEARCH_PARAMS } from '../../constants/search';
import { PAGINATION } from '../hotels/constants';

export const NUMBER_HOTELS_ADDED = 3;
export const name = 'emptyFiltration';

const initialState: EmptyFiltrationState = {
  isEmptyFiltration: false,
  showPenalizedHotels: false,
  isVisiblePenalizedHotels: false,
  penalizedHotels: [],
  hasFilteredHotels: false,
  visibleLimit: PAGINATION.VISIBLE_LIMIT,
};

const resetEmptyFiltration = (state) => ({
  ...initialState,
  visibleLimit: state.visibleLimit,
});

const emptyFiltration = createSlice({
  name,
  initialState,
  reducers: {
    setIsEmptyFiltration: (state, action: PayloadAction<boolean>) => {
      state.isEmptyFiltration = action.payload;
    },
    setIsVisiblePenalizedHotels: (state, action: PayloadAction<boolean>) => {
      state.isVisiblePenalizedHotels = action.payload;
    },
    setShowPenalizedHotels: (state) => {
      state.showPenalizedHotels = true;
    },
    setIsNotEmptyFiltration: (state) => {
      state.isEmptyFiltration = false;
    },
    setPenalizedHotelsVisibleLimit: (state, action: PayloadAction<number>) => {
      state.visibleLimit = action.payload;
    },
  },
  extraReducers: {
    [CLEAR_FILTERS]: resetEmptyFiltration,
    [CHANGE_SEARCH_PARAMS]: resetEmptyFiltration,
    [SEARCH_SUCCESS]: (
      state,
      action: PayloadAction<TransformedGGHResponse>,
    ) => {
      const penalizedHotels = action.payload.filteredHotels || [];
      const filteredHotels = action.payload.filteredHotelIds || [];

      state.penalizedHotels = penalizedHotels;
      state.hasFilteredHotels = Boolean(filteredHotels.length);
    },
  },
});

export const {
  setIsEmptyFiltration,
  setIsVisiblePenalizedHotels,
  setShowPenalizedHotels,
  setIsNotEmptyFiltration,
  setPenalizedHotelsVisibleLimit,
} = emptyFiltration.actions;

export default emptyFiltration.reducer;
